import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[required]',
    standalone: false
})
export class RequiredMarkAsteriskDirective implements OnInit {

  constructor(
    private renderer: Renderer2,
    private el: ElementRef
  ) { }

  public ngOnInit(): void {
    let parent = this.renderer.parentNode(this.el.nativeElement);

    if (parent.getElementsByTagName('LABEL').length && !parent.getElementsByClassName('required-asterisk').length) {
      parent.getElementsByTagName('LABEL')[0].innerHTML += '<span class="required-asterisk">*</span>';
    }
  }

}
